/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as SplatRouteImport } from './routes/$'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as NewPasswordRouteImport } from './routes/new-password'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as SecurityRouteImport } from './routes/security'
import { Route as SwitchRouteImport } from './routes/switch'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const SplatRoute = SplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const NewPasswordRoute = NewPasswordRouteImport.update({
  id: '/new-password',
  path: '/new-password',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const SecurityRoute = SecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => rootRouteImport,
} as any)
const SwitchRoute = SwitchRouteImport.update({
  id: '/switch',
  path: '/switch',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/new-password': typeof NewPasswordRoute
  '/profile': typeof ProfileRoute
  '/security': typeof SecurityRoute
  '/switch': typeof SwitchRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/new-password': typeof NewPasswordRoute
  '/profile': typeof ProfileRoute
  '/security': typeof SecurityRoute
  '/switch': typeof SwitchRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$': typeof SplatRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/new-password': typeof NewPasswordRoute
  '/profile': typeof ProfileRoute
  '/security': typeof SecurityRoute
  '/switch': typeof SwitchRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$'
    | '/forgot-password'
    | '/login'
    | '/new-password'
    | '/profile'
    | '/security'
    | '/switch'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$'
    | '/forgot-password'
    | '/login'
    | '/new-password'
    | '/profile'
    | '/security'
    | '/switch'
  id:
    | '__root__'
    | '/'
    | '/$'
    | '/forgot-password'
    | '/login'
    | '/new-password'
    | '/profile'
    | '/security'
    | '/switch'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  SplatRoute: typeof SplatRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  NewPasswordRoute: typeof NewPasswordRoute
  ProfileRoute: typeof ProfileRoute
  SecurityRoute: typeof SecurityRoute
  SwitchRoute: typeof SwitchRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$': {
      id: '/$'
      path: '/$'
      fullPath: '/$'
      preLoaderRoute: typeof SplatRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/new-password': {
      id: '/new-password'
      path: '/new-password'
      fullPath: '/new-password'
      preLoaderRoute: typeof NewPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/security': {
      id: '/security'
      path: '/security'
      fullPath: '/security'
      preLoaderRoute: typeof SecurityRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/switch': {
      id: '/switch'
      path: '/switch'
      fullPath: '/switch'
      preLoaderRoute: typeof SwitchRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  SplatRoute: SplatRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  NewPasswordRoute: NewPasswordRoute,
  ProfileRoute: ProfileRoute,
  SecurityRoute: SecurityRoute,
  SwitchRoute: SwitchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
